<template>
  <b-loading
    :is-full-page="true"
    v-model="isLoading"
    :can-cancel="false"
  ></b-loading>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GlobalLoading",
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>
